import { TableRow, TableCell } from '@/components/ui/table';
import { formatCurrency } from '@/utils/formatters';
import type { ParsedLPWaterfallResult } from '@/hooks/react-query/useDistributionWaterfall';

interface WaterfallLPRowProps {
  lp: ParsedLPWaterfallResult;
  currency: string;
  selectedMetric?: string | null;
}

export function WaterfallLPRow({
  lp,
  currency,
  selectedMetric,
}: WaterfallLPRowProps) {
  const currencyOpts = { currency };
  const waterfall = lp.waterfall;

  return (
    <TableRow className="hover:bg-muted/50 transition-colors">
      <TableCell className="font-medium text-sm">{lp.investor_name}</TableCell>
      {(!selectedMetric || selectedMetric === 'called_capital') && (
        <TableCell className="text-right text-sm">
          {formatCurrency(waterfall.called_capital, currencyOpts)}
        </TableCell>
      )}
      {selectedMetric === 'total_distribution_amount' && (
        <TableCell className="text-right text-sm">
          {formatCurrency(waterfall.total_distribution_amount, currencyOpts)}
        </TableCell>
      )}
      {selectedMetric === 'preferred_return_amount' && (
        <TableCell className="text-right text-sm">
          {formatCurrency(waterfall.preferred_return_amount, currencyOpts)}
        </TableCell>
      )}
      {(!selectedMetric || selectedMetric === 'total_lp') && (
        <TableCell className="text-right text-sm">
          {formatCurrency(waterfall.total_lp, currencyOpts)}
        </TableCell>
      )}
      {(!selectedMetric || selectedMetric === 'total_gp') && (
        <TableCell className="text-right text-sm">
          {formatCurrency(waterfall.total_gp, currencyOpts)}
        </TableCell>
      )}
      {selectedMetric === 'total_profit' && (
        <TableCell className="text-right text-sm">
          {formatCurrency(waterfall.total_profit, currencyOpts)}
        </TableCell>
      )}
    </TableRow>
  );
}
